import { SHOP_MAP } from 'constant/shop';
import {
  ReceptionProfession,
  ReceptionSnsPlatform,
  ReceptionVisitMotive,
} from 'types/oms';

export const isJapanReceptionStore = (storeId?: number) => {
  return storeId === SHOP_MAP.GINZA || storeId === SHOP_MAP.UMEDA;
};

export const RECEPTION_PROFESSION_OPTIONS: {
  value: ReceptionProfession;
  label: string;
}[] = [
  { value: 'company_employee', label: '会社員' },
  { value: 'company_owner', label: '会社経営' },
  { value: 'company_officer', label: '会社役員' },
  { value: 'self_employed', label: '自営業' },
  { value: 'civil_servant', label: '公務員' },
  { value: 'part_time', label: 'パート・アルバイト' },
  { value: 'student', label: '学生' },
  { value: 'homemaker', label: '専業主婦' },
  { value: 'other', label: 'その他' },
];

export const RECEPTION_VISIT_MOTIVE_OPTIONS: {
  value: ReceptionVisitMotive;
  label: string;
}[] = [
  { value: 'official_site', label: '弊社HP' },
  { value: 'sns', label: 'SNS' },
  { value: 'referral', label: 'ご紹介' },
  { value: 'passing_by', label: '通りすがり' },
  { value: 'google', label: 'Google' },
  { value: 'signboard', label: '看板' },
  { value: 'repeater', label: 'リピーター様' },
  { value: 'other', label: 'その他' },
];

export const RECEPTION_SNS_PLATFORM_OPTIONS: {
  value: ReceptionSnsPlatform;
  label: string;
}[] = [
  { value: 'instagram', label: 'Instagram' },
  { value: 'wechat', label: 'WeChat' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'red', label: '小紅書（RED）' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'ai_search', label: 'AI検索' },
];
